import { Component, EventEmitter, Input, OnInit, Output, SimpleChange, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
// import { LoaderComponent } from 'src/app/Directives/loader/loader.directive';
import { CommonServices } from 'src/app/Services/common.service';
import { VehicleLiveTrackService } from 'src/app/store/vehicle/reducer';

import { SharedService } from './../../../../Services/shared.service';
import { StorageService } from 'src/app/Services/storage.service';
import { ApiService } from 'src/app/Services/api.service';
@Component({
  selector: 'app-listview',
  templateUrl: './listview.component.html',
  styleUrls: ['./listview.component.css']
})
export class ListviewsComponent implements OnInit {

  // @Input() vehFilterSlider:boolean = true;
  // @Output() vehFilterChange = new EventEmitter();
  public tableData:any = [];

  @Input() enableMapViewBtn:boolean = true;
  @Output() selectedData = new EventEmitter();
  @Output() mapView = new EventEmitter();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  public searchInput: any = new Subject<string>();
  searchedValue: any = '';
  searchKey: any = "reg";
  selectedVehicle: any = {};
  removeVehMarker:any = {};
  mapData: any;
  mapHeight = '50vh';


  public toggleMenu:boolean = false;
  public speedFilter:number;
  public searchList = ['Moving','Halt','Overspeed','Late Update'];
  public searchOptionChanges:boolean = false;
  
  public User_type: any;
  public selectedMap:string = 'osrm';
  // public selectedMap:string = 'google';

  public listOfVehicle:any={};
  constructor(
    private storage: StorageService,
    public api: ApiService,
    private socketStore: VehicleLiveTrackService,
    private comService: CommonServices,
    private share: SharedService
  ) {
    this.User_type = this.storage.get('userType');
    let user = this.storage.get('userInfo');
    if(user && user.map){
      this.selectedMap = user.map;
    }
    this.getVehicleData();
    this.share._subject.subscribe((data: any) => {
      if (data.type == 'socketData') {
        this.loadTableData();
      }
    });
  }
/*   vehicelData = [
    { value: 'moving', viewValue: 'Moving' },
    { value: 'halt', viewValue: 'Halt' },
    { value: 'lateupdate', viewValue: 'Late update' },
  ]; */
  statusCheckboxValue = [
    { name: 'Moving', value:true},
    { name: 'Halt', value:true},
    { name: 'Overspeed', value:true},
    { name: 'Late Update', value:true },
  ];
  public dataSource: any = [];
  displayedColumns: string[] = [
    'srno',
    'vehicle',
    'status',
    'speed',
    // 'ignition',
    // 'Ac_status',
    'Temperature',
    'UpdatedOn',
    'map'
  ];
  ngOnInit(): void {
    // this.loader.s
    // this.dataSource.paginator = this.paginator;
    this.loadListView();
  }
  showSingleVehicle(item) {
    this.selectedVehicle = {};
    // console.log(item)
    this.mapData = item
    this.selectedVehicle = item;
  }
  requstTypeValue(e) {
    // console.log(e)
    this.searchKey = e
  }
  sendSelectedData(item) {
    this.selectedData.emit(item);
  }
  loadListView() {
    
    var today = new Date().setHours(0, 0, 0, 0);

    const currnentTMS = new Date().getTime();

    const restrictedDays = new Date().setDate(new Date().getDate()-2);
    const restrictedDatetime = new Date(restrictedDays).setHours(0,0,0,0);
    const restrictedTimestamp = new Date(restrictedDatetime).getTime();
    this.tableData = this.socketStore.get().filter((item: any) => {

      var thatDay = new Date((item.gpsts * 1000)).setHours(0, 0, 0, 0);  

      const timeDiff = this.comService.timeDiff((String(item.gpsts).length > 10 ? item.gpsts : item.gpsts * 1000), currnentTMS);
      if(timeDiff.hh <=48){
        if (timeDiff.hh > 4) {
          
          item.status = 'Late Update';
        }else{
          if (item.spd <= 5) {
            if(item.spd < 0) item.spd = 0;
            item.status = 'Halt';
          }else if (item.spd > 5 && item.spd <= 59) {
            
            item.status = 'Moving';
          }else if (item.spd > 59) {
            
            item.status = 'Overspeed';
          }
         /*  if (restrictedTimestamp < (item.gpsts*1000)){
          } */
  
        }    
      }
      return item;
      
      // if (timeDiff.hh > 4) {
      //   item.status = 'Late Update';
      // } else if (item.spd <= 5) {
      //   item.status = 'Halt';
      // } else if (item.spd > 5) {
      //   item.status = 'Moving';
      // }
    });
    this.dataSource = [ ...this.tableData];
  }
  modelClose (){
    
  }
// status option filter
  toggleDropdown(){
      this.toggleMenu = !this.toggleMenu;
      if (!this.toggleMenu && this.searchOptionChanges){
          this.searchOptionChanges = false;
          this.filterStatus();
          this.loadTableData(); // If dropdown closing then load data
      }
  }
  searchOption(val,index){
      this.searchOptionChanges = true;
      this.statusCheckboxValue[index]['value']=val;
  }

  filterStatus(){
      this.searchList = [];
      this.statusCheckboxValue.filter((e)=>{ if (e.value==true) this.searchList.push(e.name) });
  }
  getVehicleData() {

    this.api.transportManagerVehicleList({}).then((res: any) => {
      if (res.status == 'success') {
        if(res.data.length>0){
          for(let i=0;i<res.data.length;i++){
            this.listOfVehicle[res.data[i]['vehRegNo']]=res.data[i]['model']
          }
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  loadTableData(){
      this.loadListView();
      // this.filterChange({ checked: this.vehFilterSlider});
      if(this.speedFilter) this.speedValueFilter();
      if (this.searchList.length > 0 && this.dataSource) 
        this.dataSource = this.dataSource.filter((e)=> this.searchList.includes(e.status));    
  }

  hideSingleVehicle(vehicle){
    this.removeVehMarker = vehicle
  }

  // speed filter
  speedValueFilter(){
    let data = [];
    if(this.dataSource) this.dataSource.filter((e)=>{
      if(e.spd < this.speedFilter) data.push(e);
    })
    this.dataSource = data;
  }

  getVehicleStatus(val) {
    console.log(val)
  }
  mapBarChart(){
    this.mapView.emit(true);
  }
  // public dataDetails = [
  //   {
  //     vehicleName: 'ashok layland bus',
  //     vehicleNo: 'ABC-TN55X4001',
  //     location: '0.09km from Guindy,Chennai.',
  //     status: 'offline',
  //     speed: '0',
  //     ignition: false,
  //     Ac_status: false,
  //     Temperature: '-',
  //     UpdatedOn: '1621439529833',
  //     map: 'lattitude,longtitude'
  //   },
  //   {
  //     vehicleName: 'ashok layland bus',
  //     vehicleNo: 'BCD-TN55X4002',
  //     location: '0.09km from Velachery,Chennai.',
  //     status: 'last update',
  //     speed: '17',
  //     ignition: false,
  //     Ac_status: false,
  //     Temperature: '20',
  //     UpdatedOn: '1621439529833',
  //     map: 'lattitude,longtitude'
  //   },
  //   {
  //     vehicleName: 'ashok layland bus',
  //     vehicleNo: 'CDE-TN55X4003',
  //     location: '0.09km from Perungudi,Chennai.',
  //     status: 'halt',
  //     speed: '0',
  //     ignition: false,
  //     Ac_status: false,
  //     Temperature: '70',
  //     UpdatedOn: '1621439529833',
  //     map: 'lattitude,longtitude'
  //   },
  //   {
  //     vehicleName: 'ashok layland bus',
  //     vehicleNo: 'DEF-TN55X4004',
  //     location: '0.09km from Guindy,Chennai.',
  //     status: 'moving',
  //     speed: '45',
  //     ignition: false,
  //     Ac_status: false,
  //     Temperature: '34',
  //     UpdatedOn: '1621439529833',
  //     map: 'lattitude,longtitude'
  //   },
  //   {
  //     vehicleName: 'ashok layland bus',
  //     vehicleNo: 'EFG-TN55X4005',
  //     location: '0.09km from Guindy,Chennai.',
  //     status: 'overspeed',
  //     speed: '60',
  //     ignition: true,
  //     Ac_status: true,
  //     Temperature: '70',
  //     UpdatedOn: '1621439529833',
  //     map: 'lattitude,longtitude'
  //   },
  //   {
  //     vehicleName: 'ashok layland bus',
  //     vehicleNo: 'FGH-TN55X4006',
  //     location: '0.09km from Anna Nagar,Chennai.',
  //     status: 'offline',
  //     speed: '0',
  //     ignition: false,
  //     Ac_status: false,
  //     Temperature: '70',
  //     UpdatedOn: '1621439529833',
  //     map: 'lattitude,longtitude'
  //   }
  // ];

  // public dataSource = new MatTableDataSource(this.dataDetails);

  applyFilter(value: string) {
    this.dataSource.filter = value.trim().toLowerCase();
  }
/*   checkStatusColor(value) {
    switch (value) {
      case 'offline':
        return 'color_gray';
      case 'overspeed':
        return 'color_blue';
      case 'halt':
        return 'color_red';
      case 'moving':
        return 'color_green';
      case 'last update':
        return 'color_yellow';
    }
  } */
  checkStatusColor(value) {
    if(this.selectedMap == 'google'){
      switch (value) {
        case 'Offline':
          return 'badge-secondary';
        case 'Overspeed':
          return 'bgcolor_olive';
        case 'Halt':
          return 'badge-danger';
        case 'Moving':
          return 'bgcolor_yellow';
        case 'Late Update':
          return 'bgcolor_grey';
      }
    }else{
      switch (value) {
        case 'Offline':
          return 'badge-secondary';
        case 'Overspeed':
          return 'badge-primary';
        case 'Halt':
          return 'badge-danger';
        case 'Moving':
          return 'badge-success';
        case 'Late Update':
          return 'badge-warning';
      }
    }
  }
  checkSpeedColor(value,sts) {
    // console.log(value,sts)
    if(this.selectedMap == 'google'){
      if(sts == 'Late Update')return 'fontcolor_grey'
      if(sts == 'Halt')return 'fontcolor_red'
      if(sts == 'Moving')return 'fontcolor_yellow'
      if(sts == 'Overspeed') return 'fontcolor_olive'
    }else{
      if(sts == 'Late Update')return 'fontcolor_orange'
      if(sts == 'Halt')return 'fontcolor_red'
      if(sts == 'Moving')return 'fontcolor_green'
      if(sts == 'Overspeed') return 'fontcolor_blue'
    }

    // const spd = Number(value);
    //  if (spd > 0) {
    //    if (spd > 59) { return 'fontcolor_blue'; } else { return 'fontcolor_green'; }
    //  } else { return 'fontcolor_red'; }
  }

  
  // checkSpeedColor(value, tStatus) {
  //   var spd = Number(value);
  //   if (tStatus != 'offline') {
  //     if (spd > 0) {
  //       if (spd > 59) return 'fontcolor_blue';
  //       else return 'fontcolor_green';
  //     } else return 'fontcolor_red';
  //   } else return 'fontcolor_black';
  // }
  // filterChange(e:any){
  //   this.vehFilterSlider = e.checked;
  //   this.vehFilterChange.emit(this.vehFilterSlider);
  //   this.dataSource = this.tableData.filter((item)=>(!this.vehFilterSlider || (this.vehFilterSlider && item['act'])))
  // }

}
